module.exports = __webpack_public_path__ + "img/signup_carousel_0.7931228c.svg";